//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tabs from '@/components/Tabs';
import Tips from '@/components/Tips';
import { mapGetters } from 'vuex';
import Vlogin from '../../components/popUp';
import Noresult from '@/components/Noresult';
import api from '../../api';

export default {
    components: { Tips, Tabs, Noresult, Vlogin },
    data: () => ({
        tabsDatas: [
            { text: '全部', key: 'all' },
            { text: '进行中', key: 'doing' },
            { text: '已完成', key: 'completed' },
        ],
        type: 'all',
        tenderList: [],
    }),
    mounted() {
        if (!this.isUpper && this.isLogin) {
            this.$vux.toast.text('您不是货主, 不能访问此页面');
            this.$router.push({
                name: 'mineIndex',
            })
        }
        if (this.$route.query.type) {
            this.type = this.$route.query.type;
        }
        this.getList(this.type);
    },
    computed: {
        ...mapGetters([
            'isLower',
            'isUpper',
        ]),
        isLogin() {
            return this.$store.state.isLogin;
        },
    },
    methods: {
        tabClick(activeKey) {
            this.getList(activeKey);
        },
        toDetail(id) {
            this.$router.push({
                path: '/tendering/detail',
                query: {
                    id,
                }
            });
        },
        getList(key) {
            let param = {
                page: 1,
                size: 100,
            };
            if (key === 'doing') {
                param = {
                    page: 1,
                    size: 100,
                    stateList: [10, 30, 40, 50, 60, 70, 80],
                }
            }
            if (key === 'completed') {
                param = {
                    page: 1,
                    size: 100,
                    stateList: [90],
                }
            }
            api.vega.tender.ManagerListUp(param).then((res) => {
                const data = res.data.data;
                this.tenderList = data.list;
            })
        },
        nowStateUp(state, rounds) { // 状态机
            let t = '待审核';
            let r = '第一轮';
            let c = '';
            switch (state) {
                case 20:
                    t = '审核不通过';
                    c = 'status_danger';
                    break;
                case 30:
                    t = '报名中';
                    c = 'status_warning';
                    break;
                case 40:
                    t = '待邀标';
                    c = 'status_warning';
                    break;
                case 50:
                    t = '应标中';
                    c = 'status_danger';
                    break;
                case 60:
                    t = '待招标';
                    c = 'status_warning';
                    break;
                case 70:
                    t = '投标中';
                    c = 'status_danger';
                    break;
                case 80:
                    t = '开标中';
                    c = 'status_danger';
                    break;
                case 90:
                    t = '已完成';
                    c = 'status_success';
                    break;
                case 100:
                    t = '已关闭';
                    c = 'status_info';
                    break;
                case 110:
                    t = '已取消';
                    c = 'status_info';
                    break;
                default:
                    t = '待审核';
                    c = 'status_warning';
                    break;
            }
            switch (rounds) {
                case 2:
                    r = '第二轮报价';
                    break;
                case 3:
                    r = '第三轮报价';
                    break;
                default:
                    r = '第一轮报价';
                    break;
            }
            return {
                t,
                r,
                c,
            };
        },
        nowStateUpImg(state) { // 状态机
            let t = require('@/assets/images/review@3x.png');
            switch (state) {
                case 20:
                    t = require('../../assets/images/no-pass@3x.png');
                    break;
                case 30:
                    t = require('../../assets/images/enrolment@3x.png');
                    break;
                case 40:
                    t = require('../../assets/images/invited@3x.png');
                    break;
                case 50:
                    t = require('../../assets/images/in-the-mark@3x.png');
                    break;
                case 60:
                    t = require('../../assets/images/wait-tendering@3x.png');
                    break;
                case 70:
                    t = require('../../assets/images/tendering-3@3x.png');
                    break;
                case 80:
                    t = require('../../assets/images/open-tendering@3x.png');
                    break;
                case 90:
                    t = require('../../assets/images/complete@3x.png');;
                    break;
                case 100:
                    t = require('../../assets/images/closed@3x.png');
                    break;
                case 110:
                    t = require('../../assets/images/cencel@3x.png');;
                    break;
                default:
                    t = require('../../assets/images/review@3x.png');
                    break;
            }
            return t;
        },
    },
};
